export const ENV = process.env.NEXT_PUBLIC_ENV

export const IS_DEV = ENV === 'development'
export const IS_PROD = ENV === 'production'

const getWebAppUrl = () => {
  switch (ENV) {
    case 'qa':
      return 'https://app-qa.neat.com'
    case 'production':
      return 'https://app.neat.com'
    default:
      return 'https://app-staging.neat.com'
  }
}

const getRecurlyId = () => {
  switch (ENV) {
    case 'qa':
      return 'ewr1-C892qOUmwfN2XU9RSuigoe'
    case 'production':
      return 'ewr1-kN2T3jHWviU3IAPWWYUuqa'
    default:
      return 'ewr1-jUsi8exmOff3fntJ2rpLMo'
  }
}

const getOrderApi = () => {
  switch (ENV) {
    case 'qa':
      return 'https://squidward-qa.neat.com'
    case 'production':
      return 'https://squidward.neat.com'
    default:
      return process.env.SQUIDWARD_API_URL
  }
}

const getOrderApiToken = () => process.env.SQUIDWARD_TOKEN

const getInterrogatorUrl = () => {
  switch (ENV) {
    case 'qa':
      return 'https://interrogator-qa.neat.com/graphql'
    case 'production':
      return 'https://interrogator.neat.com/graphql'
    default:
      return process.env.INTERROGATOR_API || 'https://interrogator-staging.neat.com/graphql'
  }
}

const getAuthUrl = () => {
  switch (ENV) {
    case 'qa':
      return 'https://auth-qa.neat.com'
    case 'production':
      return 'https://auth.neat.com'
    default:
      return process.env.AUTH_URL || 'https://auth-staging.neat.com'
  }
}

export const CSRF_HARD_FAIL = process.env.CSRF_HARD_FAIL === 'true'
export const SHOW_UPSELL = process.env.NEXT_PUBLIC_SHOW_UPSELL === 'true'
export const NO_CC_TRIAL_BACKUP_OFFER_ENABLED = process.env.ORDER_FAILURE_NO_CC_TRIAL_BACKUP_OFFER_ENABLED === 'true'
export const WEB_APP_URL = getWebAppUrl()
export const RECURLY_ID = getRecurlyId()
export const ORDER_API = getOrderApi()
export const ORDER_API_TOKEN = getOrderApiToken()
export const AUTH_URL = getAuthUrl()
export const INTERROGATOR_API = getInterrogatorUrl()
export const { INTERROGATOR_JWT } = process.env

// Every environment's static-content host, so one policy serves each of them.
export const NEAT_DATA_HOSTS = [
  'https://www-data.neat.com',
  'https://www-staging-data.neat.com',
  'https://www-qa-data.neat.com',
]

// Both sites send customers to the one help center.
export const SUPPORT_URL = 'https://support.neat.com'

// Rollbar tests each pattern against a stack frame's URL, so this one admits
// both sites' hosts.
export const ROLLBAR_HOST_SAFE_LIST = ['neat.com']

// Both sites post to the same Google Forms; each entry records its environment.
export const NEWSLETTER_FORM = {
  url: 'https://docs.google.com/forms/u/0/d/e/1FAIpQLSek4wf7M0uL_8ndJpjn1YTvZEQcSRCYSdteEfxUPAjWtkxEzQ/formResponse',
  fields: {
    firstName: 'entry.130755717',
    lastName: 'entry.923545791',
    email: 'entry.637530959',
    env: 'entry.1484635168',
  },
}
export const CSP_REPORT_FORM = {
  url: 'https://docs.google.com/forms/u/0/d/e/1FAIpQLSctRc7OHZZMkue4y3AVKp4qJqkh2KKPg4pXHVZ1bVo5vJfCwQ/formResponse',
  fields: {
    env: 'entry.522760631',
    documentUrl: 'entry.2021309852',
    blockedUrl: 'entry.1025480097',
    effectiveDirective: 'entry.1834115701',
    sourceUrl: 'entry.2097759313',
    disposition: 'entry.1727466809',
  },
}

const getMinimumRecaptchaV3Score = () => {
  if (typeof process.env.RECAPTCHA_V3_SCORE_THRESHOLD !== 'string') return 0
  const minScore = Number(process.env.RECAPTCHA_V3_SCORE_THRESHOLD)
  return Number.isNaN(minScore) ? 0 : Math.min(minScore, 1)
}

const getOrderFailureNoCcTrialMinimumRecaptchaV3Score = () => {
  if (typeof process.env.ORDER_FAILURE_NO_CC_TRIAL_MINIMUM_RECAPTCHA_V3_SCORE !== 'string') return 0
  const minScore = Number(process.env.ORDER_FAILURE_NO_CC_TRIAL_MINIMUM_RECAPTCHA_V3_SCORE)
  return Number.isNaN(minScore) ? 0 : Math.min(minScore, 1)
}

export const RECAPTCHA_V3_SCORE_THRESHOLD = getMinimumRecaptchaV3Score()
export const ORDER_FAILURE_NO_CC_TRIAL_MINIMUM_RECAPTCHA_V3_SCORE = getOrderFailureNoCcTrialMinimumRecaptchaV3Score()
